import { ArrowRight } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";
import { waLink } from "../config";

const PILLARS = ["Trade & Market Research", "Data-led Analytics", "Strategic Insight"];

const NetworkGraphic = () => (
  <svg
    aria-hidden="true"
    className="absolute right-0 top-0 h-full w-full opacity-[0.55] lg:w-[64%]"
    viewBox="0 0 900 700"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
  >
    <g stroke="#1D4FC4" strokeWidth="1">
      <path d="M140 170 L340 110" />
      <path d="M340 110 L600 170" />
      <path d="M600 170 L760 330" />
      <path d="M140 170 L400 320" />
      <path d="M400 320 L600 170" />
      <path d="M400 320 L760 330" />
      <path d="M400 320 L280 520" />
      <path d="M280 520 L620 560" />
      <path d="M760 330 L620 560" />
      <path d="M600 170 L820 120" />
      <path d="M140 170 L280 520" />
    </g>
    <g fill="#1D4FC4">
      <circle cx="140" cy="170" r="4" />
      <circle cx="340" cy="110" r="3" />
      <circle cx="600" cy="170" r="5" />
      <circle cx="760" cy="330" r="3.5" />
      <circle cx="400" cy="320" r="4.5" />
      <circle cx="280" cy="520" r="3" />
      <circle cx="620" cy="560" r="4" />
      <circle cx="820" cy="120" r="3" />
    </g>
    <circle cx="470" cy="330" r="230" stroke="#1D4FC4" strokeOpacity="0.18" strokeDasharray="3 7" />
    <circle cx="470" cy="330" r="310" stroke="#0A1E42" strokeOpacity="0.1" strokeDasharray="2 8" />
    <path d="M120 560 Q470 380 860 480" stroke="#3563D6" strokeOpacity="0.28" strokeWidth="1.4" />
    <path d="M100 120 Q430 240 840 90" stroke="#0A1E42" strokeOpacity="0.16" strokeWidth="1.2" />
  </svg>
);

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-white">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -top-48 right-[-12%] h-[680px] w-[680px] rounded-full bg-[radial-gradient(circle,rgba(37,99,235,0.10),transparent_65%)]" />
        <div className="absolute -left-48 top-1/3 h-[560px] w-[560px] rounded-full bg-[radial-gradient(circle,rgba(10,30,66,0.07),transparent_65%)]" />
        <NetworkGraphic />
        <img
          src="/logo-mark.webp"
          alt=""
          aria-hidden="true"
          className="absolute -right-20 top-1/2 hidden w-[540px] -translate-y-1/2 opacity-[0.05] lg:block"
        />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-white" />
      </div>

      <div className="relative mx-auto flex min-h-[94vh] max-w-7xl flex-col justify-center px-5 pb-24 pt-36 sm:px-8">
        <p className="hero-anim eyebrow">Global Trade Intelligence</p>
        <h1 className="hero-anim hero-d1 max-w-3xl font-display text-4xl font-light leading-[1.08] tracking-[-0.01em] text-navy-900 sm:text-5xl lg:text-6xl">
          Intelligence That Powers{" "}
          <span className="font-normal italic text-royal">Global Business.</span>
        </h1>
        <p className="hero-anim hero-d2 mt-7 max-w-xl text-base leading-relaxed text-navy-900/65 sm:text-lg">
          Transforming complex business and trade information into meaningful
          insights for smarter decisions.
        </p>
        <div className="hero-anim hero-d3 mt-10 flex flex-wrap items-center gap-4">
          <a href="#expertise" data-testid="hero-expertise-cta" className="btn-primary">
            Explore Our Expertise
            <ArrowRight className="h-4 w-4" />
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-whatsapp-cta"
            className="btn-secondary"
          >
            <WhatsAppIcon className="h-4 w-4 text-[#1FAF54]" />
            Connect on WhatsApp
          </a>
        </div>
        <div className="hero-anim hero-d4 mt-20 flex flex-wrap gap-x-12 gap-y-4 border-t border-navy-900/10 pt-7">
          {PILLARS.map((p) => (
            <span
              key={p}
              className="text-[11px] font-semibold uppercase tracking-[0.22em] text-navy-900/45"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
